// extracted by mini-css-extract-plugin
export var actionButton = "_9e-1";
export var actionButtons = "_9e-2";
export var actions = "_9e-0";
export var aiUnread = "_9e-10";
export var alignCenter = "_9e-h";
export var backWrapper = "_9e-3";
export var cellContainer = "_9e-4";
export var checkboxContainer = "_9e-5";
export var contentContainer = "_9e-6";
export var contentHeader = "_9e-8";
export var conversationsTableWrapper = "_9e-s";
export var draftReplyBadgeContainer = "_9e-m";
export var dropdownItem = "_9e-b";
export var dropdownItemsContainer = "_9e-a";
export var dropdownTitle = "_9e-c";
export var errorIcon = "_9e-7";
export var filter = "_9e-d";
export var gray = "_9e-i";
export var headerActionButtons = "_9e-e";
export var headerCheckboxContainer = "_9e-f";
export var icon = "_9e-j";
export var menuContainer = "_9e-k";
export var noMoreTicketsIcon = "_9e-12";
export var noMoreTicketsSubText = "_9e-13";
export var oneLine = "_9e-l";
export var optionsButton = "_9e-n";
export var plus = "_9e-o";
export var portalButtonsWrapper = "_9e-g";
export var red = "_9e-p";
export var scrolledTop = "_9e-9";
export var search = "_9e-q";
export var selectedConversationsCount = "_9e-r";
export var spinner = "_9e-t";
export var strong = "_9e-u";
export var summaryCell = "_9e-v";
export var tableContainer = "_9e-11";
export var tagContainer = "_9e-w";
export var threeDots = "_9e-x";
export var twoLines = "_9e-y";
export var unread = "_9e-z";